module.exports = __webpack_public_path__ + "img/various.fixes.bd41dacb.jpeg";